import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query'
import { useAuth } from '../components/auth/AuthContext'

const endpointUrl = process.env.REACT_APP_ENDPOINT_ADDITIONAL_INFORMATION

export const maxStringLength = 100

export type AdditionalInformation = {
  occupation?: string,
  employer?: string,
  placeOfBirth: string,
  otherNationalities?: Array<string>,
  nonFiscalAddress?: Array<string>,
  relationshipPurpose?: string
  businessArea?: string,
  businessRevenue?: string,
  businessHighRiskCountries?: Array<string>,
}

type RequestData = {
  profissao?: string,
  entidadePatronal?: string,
  naturalidade: string,
  nacionalidadesExtra?: Array<string>,
  enderecoNaoFiscal?: Array<string>,
  objetivo?: string,
  ramoNegocio?: string,
  receitaAnualNegocio?: string,
  paisesRiscoNegocio?: Array<string>,
}

type ServerResponse = {
  success: boolean
}

export async function sendAdditionalInformation(
  token: string,
  tokenType: string,
  additionalInformation: AdditionalInformation
): Promise<ServerResponse> {
  if (!endpointUrl || !token || !tokenType) {
    throw new Error('sendAdditionalInformation: missing status endpoint or token information')
  }

  const requestData: RequestData = {
    profissao: additionalInformation.occupation,
    entidadePatronal: additionalInformation.employer,
    naturalidade: additionalInformation.placeOfBirth,
    nacionalidadesExtra: additionalInformation.otherNationalities,
    enderecoNaoFiscal: additionalInformation.nonFiscalAddress,
    objetivo: additionalInformation.relationshipPurpose,
    ramoNegocio: additionalInformation.businessArea,
    receitaAnualNegocio: additionalInformation.businessRevenue,
    paisesRiscoNegocio: additionalInformation.businessHighRiskCountries,
  }

  try {
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        Authorization: `${tokenType} ${token}`
      },
      body: JSON.stringify(requestData)
    })

    if (!response.ok) {
      throw new Error('sendAdditionalInformation: failed to send additional information')
    }

    const result: ServerResponse = await response.json()
    return result
  } catch (error: any) {
    throw new Error('getStatus: failed to parse response')
  }

  /*
    // Mocks
    throw new Error('rejected')
    await new Promise((resolve) => setTimeout(resolve, 2000))
    return {success: true}
  */
}

export function useSendAdditionalInformation(options: UseMutationOptions<ServerResponse, Error, AdditionalInformation> = {}): UseMutationResult<ServerResponse, Error, AdditionalInformation> {
  const {
    tokenInfo
  } = useAuth()
  const { token, tokenType } = tokenInfo || {}

  return useMutation<ServerResponse, Error, AdditionalInformation>(
    (requestData: AdditionalInformation): Promise<ServerResponse> => {
      if (!token || !tokenType) throw new Error('useStatus: missing token or tokenType')

      try {
        return sendAdditionalInformation(token, tokenType, requestData)
      } catch (error) {
        throw error
      }
    },
    options
  )
}
